import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import usePceSearchV2 from './usePceSearchV2'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import useMeterSearchStyles from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useMeterSearchStyles'

const PceSearchButton = ({ hidden = false }) => {
  const { t } = useTranslation()
  const { openButtonKind, openButtonOverrides } = useMeterSearchStyles()
  const { updatePceConfigData } = usePceSearchV2()

  const handleOpenModal = () => {
    updatePceConfigData({ isOpen: true })
  }

  if (hidden) return null

  return (
    <SDButton
      overrides={openButtonOverrides}
      kind={openButtonKind}
      size={SIZE.compact}
      id='pce-search-open-modal'
      onClick={handleOpenModal}
    >
      {t('subscriptionForm:pce_module.search_text_v2')}
    </SDButton>
  )
}

export default PceSearchButton
